import Rate from './components/Rate';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'rate',
  pluginComponent: Rate,
});
